module.exports = __webpack_public_path__ + "img/document_front_back.c24f8c6e.svg";